<template>
  <table>
    <thead>
      <tr>
        <th v-for="header in headers">
          {{ header.text }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ $t('contentGoesHere') }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'data-table',
  props: {
    headers: {
      type: Array,
      default () {
        return [{ text: 'Column', left: true, value: 'prNumber' }]
      },
    },
    items: {
      type: Array,
      default () { },
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
